export default "__VITE_ASSET__81814ca5__"